export enum OptionHeaderStyleEnum {
    DEFAULT = 0,
    ROYAL = 1
}
